<template>
  <v-dialog
    v-model="show"
    @click:outside="$emit('close')"
    scrollable
    :width="cfgUI.modal.size"
    :content-class="cfgUI.modal.margin"
  >
    <v-card class="overflow-hidden">
      <v-card-title class="Modal-header justify-center pa-0">
        <v-row justify="center" align="center">
          <v-icon color="red" class="Modal-iconInfo" :size="cfgUI.icon">mdi-alert-circle</v-icon>
          <v-col cols="9" class="flex-column text-center">
            <div class="Modal-title text-break pb-2" data-e2e="AppointmentChangesModalTitle">
              {{ appointments.length }} {{ $t(`appointmentChangesModal.title.${textVariant}`) }}
            </div>
            <div class="Modal-subtitle text-break" data-e2e="AppointmentChangesModalSubtitle">
              {{ $t(`appointmentChangesModal.subtitle.${textVariant}`) }}
            </div>
          </v-col>
          <v-icon
            size="2rem"
            class="Modal-closeBtn"
            @click="$emit('close')"
            data-e2e="AppointmentChangesModalCloseButton"
            >mdi-close</v-icon
          >
        </v-row>
        <v-alert v-if="confirmCancel" class="Modal-alert mb-0" type="info" dense tile>{{
          $t('appointmentChangesModal.confirmationCancelAppointmentMessage')
        }}</v-alert>
      </v-card-title>

      <v-card-text style="height: 500px;">
        <AppointmentCard
          v-for="appointment in filteredAppointment"
          :key="appointment.appointmentId"
          :selectedAppointment="appointment"
          :options="['customerPhoneNumber', 'customerFullName']"
          :readonly="readonly"
          small
          @cancel="cancelAppointment(appointment.appointmentId)"
          data-e2e="AppointmentChangesModalAppointmentCard"
        />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import AppointmentCard from '@/components/calendar/AppointmentCard'

export default {
  name: 'AppointmentChangesModal',

  components: { AppointmentCard },

  props: {
    appointments: {
      required: true,
      type: Array,
      validator(appointments) {
        const keyList = [
          'appointmentId',
          'beginDateTime',
          'customerPhoneNumber',
          'customerFullName',
          'endDateTime',
          'serviceType'
        ]
        return Object.keys(appointments).every(key => keyList.includes(key))
      }
    },
    readonly: {
      type: Boolean,
      default: false
    },
    show: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      confirmCancel: false
    }
  },

  computed: {
    cfgUI() {
      let modal = { size: '50%', margin: '' }
      let icon = '3.5rem'
      const bp = this.$vuetify.breakpoint.name
      if (bp === 'xs' || bp === 'sm') {
        modal = { size: '95%', margin: 'ma-0' }
        icon = '3rem'
      } else if (bp === 'md') {
        modal.size = '70%'
      }
      return { modal, icon }
    },
    textVariant() {
      return this.appointments.length > 1 ? 'plural' : 'single'
    },
    // TODO TEMP **DUPLICATE FORMATTING HOUR BLOCK**
    filteredAppointment() {
      return this.appointments.map(appointment => ({
        ...appointment,
        name: this.$t(`services.${appointment.service.serviceType}`),
        start: appointment.beginDateTime // to replace with date service
          .toISOString()
          .replace(/T/, ' ')
          .replace(/:..\..+/, ''),
        end: appointment.endDateTime
          .toISOString()
          .replace(/T/, ' ')
          .replace(/:..\..+/, '')
      }))
    }
  },

  methods: {
    cancelAppointment(appointmentId) {
      this.$emit('cancelAppointment', appointmentId)
      this.confirmCancel = true
      setTimeout(() => (this.confirmCancel = false), 3000)
    }
  }
}
</script>

<style scoped lang="scss">
.Modal-header {
  position: relative;
  background-color: var(--v-secondary-lighten2);
}

.Modal-closeBtn {
  position: absolute;
  top: 0.2rem;
  right: 0.2rem;
}

.Modal-iconInfo {
  position: absolute;
  left: 0.5rem;
}

.Modal-title {
  color: var(--v-secondary-base);
  font-weight: bold;
}

.Modal-subtitle {
  color: var(--v-secondary-base);
  font-size: 0.95rem;
  font-weight: 300;
  line-height: 1.5;
}

.Modal-alert {
  position: absolute;
  bottom: 0;
  right: 0;
  left: 0;
  transform: translateY(100%);
  z-index: 10;
}
</style>
